'use client'

import { useEffect, useRef } from 'react'
import { getNotificationPrefs } from '@/lib/notifications/prefs'

const SOUND_PATH = '/sounds/notification.mp3'
/** Rajada de notificações não vira metralhadora de beeps. */
const DEBOUNCE_MS = 1000

/**
 * Toca o som quando o contador de `new` sobe. Não toca no primeiro valor
 * observado — no boot o contador já vem preenchido e isso não é "chegada".
 *
 * O browser bloqueia autoplay até haver gesto do usuário; o banner de primeira
 * chegada serve como esse gesto.
 */
export function useNotificationSoundOnArrival(count: number): void {
  const previousRef = useRef<number | null>(null)
  const lastPlayedRef = useRef(0)

  useEffect(() => {
    const previous = previousRef.current
    previousRef.current = count

    if (previous === null) return
    if (count <= previous) return
    if (!getNotificationPrefs().soundEnabled) return

    const now = Date.now()
    if (now - lastPlayedRef.current < DEBOUNCE_MS) return
    lastPlayedRef.current = now

    const audio = new Audio(SOUND_PATH)
    audio.volume = 0.5
    void audio.play().catch(() => {
      /* autoplay bloqueado — silêncio é aceitável, o sino já mostra o número */
    })
  }, [count])
}
